export default [
  { id: 1, name: "BMW", price: 100 },
  { id: 2, name: "Toyota", price: 120 },
  { id: 3, name: "Audi", price: 150 },
  { id: 4, name: "Tesla", price: 200 },
  { id: 5, name: "Orion", price: 180 }
];



// WEBPACK FOOTER //
// ./src/data/stocks.js